export default {
  id: 'teams_promote_content_shares_read_only',
  title: 'Promote content shares (read only)',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'MANY_CONTENT' ],
  description: 'Send up to 4 selected pieces of content to your employees so they can easily share them across their network.',
  body: {
    attachments: [],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_INTRODUCTION_TEXT]]</p>
        <BLOCK_CONTENT>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  blocks: {
    BLOCK_CONTENT: id => `<attachment id='${id}'></attachment>`,
  },
  attachment(id, contentShareType = 'default') {
    let content = {};
    const generateContent = (items) => ({
      type: 'AdaptiveCard',
      version: '1.5',
      $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
      body: [
        {
          type: 'Container',
          separator: true,
          items: [
            {
              type: 'ColumnSet',
              columns: [
                {
                  type: 'Column',
                  width: 'stretch',
                  items: [
                    {
                      type: 'TextBlock',
                      text: '{{CONTENT_[ID]_TITLE}}',
                      wrap: true,
                      weight: 'Bolder',
                      size: 'Medium'
                    },
                    {
                      type: 'TextBlock',
                      text: '{{CONTENT_[ID]_DESCRIPTION}}',
                      wrap: true
                    }
                  ]
                },
                {
                  type: 'Column',
                  width: 'auto',
                  items: [
                    {
                      type: 'Image',
                      url: '{{CONTENT_[ID]_IMAGE_URL}}',
                      size: 'Medium',
                      altText: '{{CONTENT_[ID]_TITLE}}'
                    }
                  ]
                }
              ]
            },
            ...items
          ]
        },
      ],
      msTeams: {
        width: 'Full'
      }
    });
    content = generateContent([
      {
        type: 'ActionSet',
        actions: [
          {
            type: 'Action.OpenUrl',
            title: 'See Content',
            url: '{{CONTENT_[ID]_SEE_CONTENT_LINK}}'
          }
        ]
      }
    ]);
    const attachment = {
      id,
      contentType: 'application/vnd.microsoft.card.adaptive',
      name: null,
      thumbnailUrl: null,
      contentUrl: null,
      content: JSON.stringify(content)
    };

    return attachment;
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following pieces of content with your network to win rewards! ...',
      defaultValue: 'Share the following pieces of content with your network to win rewards!',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/promoteContentSharesReadOnly.js